<template>
    <div>
        <TButton 
            @click="showModal = true" 
            class="tw-mr-2 tw-text-black tw-bg-white tw-border tw-border-gray-500 hover:tw-bg-white"
        >
            <span class="mdi mdi-send tw-mr-2"> </span>
            <span class="">Send test</span>
        </TButton>
        <TModal 
            class="tw-w-30"
            v-model="showModal">
                <div class="" style="width: 500px;">
                    <div class="tw-mb-2 tw-text-2xl">Send test</div>
                    <TField label="Recipients" class="tw-text-gray-500 tw-mb-2">
                        <TTagInput
                            placeholder="Add an email"
                            v-model="recipients"></TTagInput>
                    </TField>
                    <TField :key="i + f.name" v-for="(f,i) in fields" :label="f.name">
                        <TInput v-model="f.value"></TInput>
                    </TField>
                    <div class="tw-flex tw-justify-end">
                        <TButton 
                            class="tw-text-white tw-bg-blue-600 hover:tw-bg-blue-500"
                            :loading="loading" :disabled="disabled" @click="send">Send</TButton>
                        <TButton 
                            class="tw-ml-2 tw-bg-white tw-border tw-border-gray-500 tw-text-gray-900 hover:tw-border-gray-400 hover:tw-bg-white"
                            @click="close">Cancel</TButton>
                    </div>
                </div>
        </TModal>
    </div>
</template>
<script>
import { useToast } from "vue-toastification";
import Auth         from '@/core/auth';
import axios        from 'axios';

import {
    TModal,
    TInput,
    TField,
    TTagInput,
    TButton
} from '@roonlabs/vue-tailwind'

export default {
    components: {
        TModal,
        TInput,
        TField,
        TTagInput,
        TButton
    },
    props: {
        comm: {
            type: Object,
            required: true
        },
        comm_type: {
            type: String,
            required: true
        },
        content: {
            type: Object,
            required: true
        },
        size: {
            type: String,
            default: 'is-regular'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading:    false,
            showModal:  false,
            recipients: [],
            fields:     [],
        }
    },
    created() {
        if ( Auth.state?.email ) {
            this.recipients = [Auth.state.email];
        }
    },
    setup() {
        const toast = useToast();
        return { toast }
    },

    /*
    @Watch('showModal') 
    watchShowModal() {
        if ( this.showModal ) {
            const m = {};
            for ( let field of this.getFields() ) {
                m[field] = { name: field, value: null }
            }
            for ( let field of this.fields ) {
                if ( !m[field.name] ) continue;
                m[field.name] = { name: field.name, value: field.value }
            }

            this.fields = Object.values(m);
        }
    }
     */
    methods: {
        close() {
            if ( Auth.state?.email && !this.recipients.find(x => Auth.state.email) ) {
                this.recipients.unshift(Auth.state.email)
            }
            this.showModal = false;
        },
        getFields() {
            const HANDLEBARS_REGEX = /\{\{\s*([0-9a-zA-Z_\$]+)\s*\}\}/g;
            const content_fields   = [];
            if ( this.comm_type == 'email' ) {
                const matches =  [
                    ...(this.content.body?.html || '').matchAll(HANDLEBARS_REGEX),
                    ...(this.content.body?.text || '').matchAll(HANDLEBARS_REGEX),
                    ...(this.content.subject    || '').matchAll(HANDLEBARS_REGEX),
                ]
                for ( let match of matches ) {
                    if ( match[1] === 'raw' ) continue
                        if ( match[1] === undefined || match[1] === null || match[1] === '' ) continue 
                            content_fields.push(match[1]);
                }
            } else if ( this.comm_type == 'in-app' ){
                const matches =  []
                for ( let template of this.content.templates || [] ) { 
                    matches.push(...(template.title          || '').matchAll(HANDLEBARS_REGEX));
                    matches.push(...(template.body           || '').matchAll(HANDLEBARS_REGEX));
                    matches.push(...(template.actionUrl      || '').matchAll(HANDLEBARS_REGEX));
                    matches.push(...(template.actionLabel    || '').matchAll(HANDLEBARS_REGEX));
                    matches.push(...(template.data?.clickUrl || '').matchAll(HANDLEBARS_REGEX));
                }
                for ( let match of matches ) {
                    if ( match[1] === 'raw' ) continue
                        if ( match[1] === undefined || match[1] === null || match[1] === '' ) continue 
                            content_fields.push(match[1]);
                }
            }

            return content_fields
        },
        async send() {
            this.loading = true
            try {
                const data = {
                    user_id: Auth.state?.userid
                };
                for ( let field of this.fields ) data[field.name] = field.value;
                const body = {
                    recipients: this.recipients,
                    comm_type:  this.comm_type,
                    content:    this.content,
                    variable_substitution: !!this.comm.variable_substitution,
                    data,
                }
                const res = await axios.post(`/api/1/comms/send`, body)
                this.toast.success(`Success, message sent.`)
                this.close();
            } catch (e) {
                console.log(e)
                this.toast.error(`Error sending message.`)
            }
            this.loading = false;
        }
    }
}
</script>
